import React from 'react';

export default function InvoiceEinvoiceLockBanner({ mode, message }) {
    if (!mode || mode === 'editable' || !message) {
        return null;
    }

    const bannerClass = mode === 'locked'
        ? 'invoice-einvoice-lock-banner-locked'
        : mode === 'cancelled'
            ? 'invoice-einvoice-lock-banner-cancelled'
            : 'invoice-einvoice-lock-banner-sync';

    const title = mode === 'locked'
        ? 'E-Invoice issued — invoice is read-only'
        : mode === 'cancelled'
            ? 'Invoice cancelled (inactive)'
            : 'E-Invoice posted — sync IRN only';

    return (
        <div className={`invoice-einvoice-lock-banner ${bannerClass}`}>
            <strong>{title}</strong>
            <p>{message}</p>
        </div>
    );
}
